import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { CommonConfig } from "../../CommonConfig.js";
import SimpleBackdrop from "../../utils/general.js";
import api from "../../utils/api.js";
import cogoToast from "cogo-toast";
import APIConstant from "../../utils/constant.js";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from "@material-ui/core/TextField";
import Loader from "components/Shared/Loader/Loader";
import { InputSwitch } from "primereact/inputswitch";

class BrandMaster extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      MasterID: "",
      loading: false,
      UserId: "",
      Token: "",
      GetMasterList: [],
      rowsPerPageOptions: CommonConfig.dataTableConfig.rowsPerPageOptions,
      rowsPerPage: CommonConfig.dataTableConfig.rowsPerPage,
      search: null,

      brandName: "",
      brandNameErr: false,
      brandNameErrText: "",
      brandStatus: true,

      AddMasterModal: false,
      EditMasterBrandModal: false,
      DeleteMasterBrandModal: false,
      cargoBrandList: [],
      userPageAccess: [],
    };
  }

  componentDidMount = async () => {
    let data = localStorage.getItem("Infodata");
    let Userrole = JSON.parse(localStorage.getItem("Userdata"));
    let token = localStorage.getItem("Token");
    let userPageAccess = localStorage.getItem("PageAccess");
    let lockstatus = localStorage.getItem("LockStatus");
    // if (lockstatus == 0) {
    if (token !== null) {
      this.setState({
        UserId: data,
        Token: token,
        userPageAccess: userPageAccess,
      });
      await this.GetBrandMaster(data);
    } else {
      this.props.history.push("/login");
    }
    // } else {
    //     this.props.history.push('/auth/lockscreen')
    // }
  };

  actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  actionTemplate = (rowData, props) => {
    return (
      <div class="bill-action icon-only-btn" style={{ display: "flex" }}>
        {this.state.userPageAccess.includes("Edit Brand") ? (
          <div onClick={(e) => this.handleOpen(rowData, "EditMasterBrand")}>
            {" "}
            <i class="icon-editImage"></i>{" "}
          </div>
        ) : null}
        {this.state.userPageAccess.includes("Delete Brand") ? (
          <div onClick={(e) => this.handleOpen(rowData, "DeleteMasterBrand")}>
            {" "}
            <i class="icon-delete"></i>{" "}
          </div>
        ) : null}
      </div>
    );
  };

  GetBrandMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetBrandMaster, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");

          this.setState({ GetMasterList: filterArry });
        }
      })
      .catch((err) => {});
  };

  GetBrandMasterById = async (MasterId) => {
    // Loader.show();
    let params = {
      MasterId,
    };
    api
      .post(APIConstant.path.GetBrandMasterById, params)
      .then((response) => {
        console.log(response);
        if (response.Success === 1) {
          // Loader.hide();
          this.setState({
            brandName: response.Data.BrandName,
            MasterID: response.Data.BrandMasterId,
          });
        } else {
          // Loader.hide();
        }
      })
      .catch((err) => {
        Loader.hide();
      });
  };

  handleOpen = (item, brand) => {
    if (brand === "AddMaster") {
      this.setState({ AddMasterModal: true });
    } else if (brand === "EditMasterBrand") {
      this.GetBrandMasterById(item.BrandMasterId);
      this.setState({
        AddMasterModal: true,
        MasterLabelName: item.label,
        MasterID: item.BrandMasterId,
      });
    } else if (brand === "DeleteMasterBrand") {
      this.setState({
        DeleteMasterBrandModal: true,
        MasterID: item.BrandMasterId,
      });
    }
  };

  handleClose = (brand) => {
    if (brand === "AddMaster") {
      this.setState({
        AddMasterModal: false,

        brandName: "",
        brandNameErr: false,
        brandNameErrText: "",

        MasterID: "",
      });
    } else if (brand === "EditMasterBrand") {
      this.setState({ EditMasterBrandModal: false });
    } else if (brand === "DeleteMasterBrand") {
      this.setState({ DeleteMasterBrandModal: false, MasterID: "" });
    }
  };

  handleChange = (e, brand) => {
    if (brand === "brandName") {
      if (CommonConfig.isEmpty(e.target.value)) {
        this.setState({
          brandName: e.target.value,
          brandNameErr: true,
          brandNameErrText: `Please enter Brand Name.`,
        });
      } else {
        this.setState({
          brandName: e.target.value,
          brandNameErr: false,
          brandNameErrText: "",
        });
      }
    }
  };

  validation = () => {
    let formIsValid = true;
    if (CommonConfig.isEmpty(this.state.brandName)) {
      this.setState({
        brandName: "",
        brandNameErr: true,
        brandNameErrText: "name is required.",
      });
      formIsValid = false;
    } else {
      this.setState({ brandNameErr: false, brandNameErrText: "" });
    }

    return formIsValid;
  };

  AddMaster = (data) => {
    if (this.validation() || data) {
      this.setState({ loading: true });

      let params = {
        BrandName: this.state.brandName,
        BrandMasterID: this.state.MasterID,
        UserID: this.state.UserId,
      };
      if (!this.state.MasterID) {
        params.BrandStatus = true;
      }
      if (data) {
        params = {
          BrandName: data.BrandName,
          BrandMasterID: data._id,
          BrandStatus: data.BrandStatus,
          UserID: this.state.UserId,
        };
      }
      api.post(APIConstant.path.AddUpdateBrandMaster, params).then((res) => {
        if (res.Success == 1) {
          this.setState({ loading: false });
          this.handleClose("AddMaster");
          this.GetBrandMaster(this.state.UserId);
          cogoToast.success(res.Message);
        } else {
          this.setState({ loading: false });
          cogoToast.error(res.Message);
        }
      });
    }
  };

  DeleteMasterBrand = () => {
    this.setState({ loading: true });
    let params = {
      ID: this.state.MasterID,
      UserId: this.state.UserId,
    };
    api.post(APIConstant.path.DeleteBrandMaster, params).then((res) => {
      if (res.Success == 1) {
        this.setState({
          loading: false,
          DeleteMasterBrandModal: false,
          MasterID: "",
        });
        this.GetBrandMaster(this.state.UserId);
        cogoToast.success(res.Message);
      } else {
        this.setState({ loading: false });
        cogoToast.error(res.Message);
      }
    });
  };

  render() {
    const {
      UserId,
      search,
      userPageAccess,
      GetMasterList,
      MasterLabelName,
      MasterLabelNameErr,
      MasterLabelNameErrText,
      AddMasterModal,
      EditMasterBrandModal,
      DeleteMasterBrandModal,
      MasterID,
      brandName,
      brandNameErr,
      brandNameErrText,
    } = this.state;

    let filterGetMasterList = [];
    if (GetMasterList.length) {
      filterGetMasterList = GetMasterList;
      if (search) {
        filterGetMasterList = filterGetMasterList.filter((x) => {
          return x.BrandName.toLowerCase().indexOf(search.toLowerCase()) !== -1;
        });
      }
    }

    return (
      <div className="wayment-owner-dashboard e-weighment-dashoard">
        <div className="heading-area p-d-flex p-ai-center p-jc-between">
          <div className="p-d-flex p-ai-center">
            <i className="pi pi-bolt"></i>
            <h2>Brand Master</h2>
          </div>
          <div className="p-d-flex p-ai-center wb-filter-btn">
            <div className="searchbar-area p-as-center">
              <InputText
                brand="search"
                onInput={(e) => this.setState({ search: e.target.value })}
                placeholder="Global Search"
                size="30"
                style={{ marginRight: 10 }}
              />
              <i className="icon-search"></i>
            </div>
            {userPageAccess.includes("Add Brand") ? (
              <div>
                <div
                  className="e-add-btn"
                  onClick={(e) => this.handleOpen(e, "AddMaster")}
                >
                  <i className="icon-add"></i>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <hr />
        <div className="main-access-card-master">
          {userPageAccess.includes("View Brand") ? (
            <DataTable
              className="main-table table-td"
              value={filterGetMasterList}
              editMode="row"
              dataKey="id"
              responsiveLayout="scroll"
              paginator={true}
              rows={this.state.rowsPerPage}
              totalRecords={filterGetMasterList.length}
              rowsPerPageOptions={this.state.rowsPerPageOptions}
              globalFilter={search}
              emptyMessage="No records found"
              responsive={false}
              resizableColumns={true}
              columnResizeMode="fit"
              scrollable={true}
              scrollWidth="auto"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            >
              <Column
                field="Index"
                header="Sr.No"
                body={this.actionBodyTemplateSrNo}
                style={{ width: "20%" }}
              ></Column>
              <Column
                field="BrandName"
                header="Brand Name"
                style={{ width: "20%" }}
              ></Column>
              <Column
                field="BrandStatus"
                header="Brand Status"
                style={{ width: "20%" }}
                body={(rowData, props) => {
                  return (
                    <InputSwitch
                      checked={rowData.BrandStatus}
                      onChange={(e) => {
                        let tempList = [...GetMasterList];
                        let index = GetMasterList.findIndex(
                          (item) => item._id === tempList[props.rowIndex]._id
                        );
                        if (index >= 0) {
                          tempList[index].BrandStatus = e.value;
                          this.setState({
                            GetMasterList: tempList,
                          });
                          this.AddMaster(tempList[index]);
                        }
                      }}
                    />
                  );
                }}
              ></Column>
              <Column
                field="Action"
                header="Action"
                body={this.actionTemplate}
                headerStyle={{ width: "10%", minWidth: "8rem" }}
                bodyStyle={{ textAlign: "center" }}
              ></Column>
            </DataTable>
          ) : null}
          {/* Add Edit BL Brand */}
          <Dialog
            open={AddMasterModal}
            onClose={() => this.handleClose("AddMaster")}
            aria-labelledby="cha-form-dialog-title"
          >
            <DialogTitle
              id="cha-form-dialog-title"
              className="custom-dialog-header"
            >
              <div>{MasterID !== "" ? "Edit" : "Add"} Brand Master</div>
              <div
                className="dialog-close"
                onClick={(e) => this.handleClose("AddMaster")}
              >
                <i className="icon-modal-close"></i>
              </div>
            </DialogTitle>
            <DialogContent className="CHA-dialog-content-area">
              <GridContainer>
                <GridItem md={12}>
                  <TextField
                    autoFocus
                    margin="dense"
                    name="BrandName"
                    // id="chaNo"
                    label="Brand Name*"
                    brand="text"
                    value={brandName}
                    onChange={(e) => this.handleChange(e, "brandName")}
                    error={brandNameErr}
                    helperText={brandNameErrText}
                    inputProps={{ maxLength: 50 }}
                    fullWidth
                  />
                </GridItem>
              </GridContainer>
            </DialogContent>
            <DialogActions className="p-p-0 dialog-footer1">
              <Button
                className="primary-btn1"
                onClick={(e) => this.handleClose("AddMaster")}
              >
                Cancel
              </Button>
              <Button
                className="primary-btn"
                onClick={(e) => this.AddMaster()}
                brand="submit"
                disabled={this.state.loading}
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>

          {/* Modal For Delete */}
          <Dialog
            open={DeleteMasterBrandModal}
            onClose={() => this.handleClose("DeleteMasterBrand")}
            aria-labelledby="cha-form-dialog-title"
          >
            <DialogTitle
              id="cha-form-dialog-title"
              className="custom-dialog-header"
            >
              <div>Delete Brand Master</div>
              <div
                className="dialog-close"
                onClick={(e) => this.handleClose("DeleteMasterBrand")}
              >
                <i className="icon-modal-close"></i>
              </div>
            </DialogTitle>
            <DialogContent className="CHA-dialog-content-area">
              <h6>Are you sure want to delete this brand?</h6>
            </DialogContent>
            <DialogActions className="p-p-0 dialog-footer1">
              <Button
                className="primary-btn1"
                onClick={(e) => this.handleClose("DeleteMasterBrand")}
              >
               Cancel
              </Button>
              <Button
                className="primary-btn"
                onClick={(e) => this.DeleteMasterBrand(e)}
                brand="submit"
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}
export default BrandMaster;
